/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 18-08-2026 10:28:42
 * Autor     : Diego Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StepUpAuthService } from '../../../services/step-up-auth.service';
import {
  STEP_UP_WRONG_PASSWORD,
  StepUpHttpError,
} from '../../../services/step-up-errors';

export interface CommandAuthDialogData {
  commandName?: string;
  error?: string;
  message?: string;
}

/**
 * Dialog de confirmação de senha (step-up).
 * Copia o fluxo do setera-admin-web: POST /auth/step-up e token one-shot em kc-auth.
 */
@Component({
  selector: 'app-command-auth-dialog',
  templateUrl: './command-auth-dialog.component.html',
  styleUrls: ['./command-auth-dialog.component.scss']
})
export class CommandAuthDialogComponent {
  password = '';
  loading = false;
  errorMessage = '';
  message: string;
  commandName: string;

  constructor(
    private stepUpAuth: StepUpAuthService,
    private dialogRef: MatDialogRef<CommandAuthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: CommandAuthDialogData
  ) {
    this.commandName = (data && data.commandName) || '';
    this.errorMessage = (data && data.error) || '';
    this.message =
      (data && data.message) ||
      'Este comando exige reautenticação. Digite sua senha para continuar.';
  }

  /**
   * Fecha o dialog sem autenticar.
   */
  cancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Envia a senha para /auth/step-up e fecha com sucesso se o token for gravado.
   */
  async confirm(): Promise<void> {
    const trimmed = (this.password || '').trim();
    if (!trimmed) {
      this.errorMessage = 'Informe a senha.';
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    try {
      await this.stepUpAuth.stepUp(trimmed);
      this.dialogRef.close(true);
    } catch (error) {
      const mapped = error as StepUpHttpError;
      if (mapped && mapped.code === STEP_UP_WRONG_PASSWORD) {
        this.errorMessage = 'Senha incorreta. Tente novamente.';
        this.password = '';
      } else if (mapped && mapped.message) {
        this.errorMessage = mapped.message;
      } else {
        this.errorMessage = 'Erro ao validar senha.';
      }
    } finally {
      this.loading = false;
    }
  }
}
